import { render, staticRenderFns } from "./studentChoose.vue?vue&type=template&id=6b9ce3d8&scoped=true&"
import script from "./studentChoose.vue?vue&type=script&lang=js&"
export * from "./studentChoose.vue?vue&type=script&lang=js&"
import style0 from "./studentChoose.vue?vue&type=style&index=0&id=6b9ce3d8&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b9ce3d8",
  null
  
)

export default component.exports